import * as React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function UserIcon() {
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/forbid-elements
    _jsxs("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "40",
      height: "40",
      viewBox: "0 0 40 40",
      fill: "none",
      children: [/*#__PURE__*/_jsx("g", {
        clipPath: "url(#clip0_7168_65343)",
        children: /*#__PURE__*/_jsx("path", {
          d: "M20 20C22.4862 20 24.5 17.9862 24.5 15.5C24.5 13.0138 22.4862 11 20 11C17.5138 11 15.5 13.0138 15.5 15.5C15.5 17.9862 17.5138 20 20 20ZM20 22.25C16.9963 22.25 11 23.7575 11 26.75V29H29V26.75C29 23.7575 23.0037 22.25 20 22.25Z",
          fill: "#707A95"
        })
      }), /*#__PURE__*/_jsx("defs", {
        children: /*#__PURE__*/_jsx("clipPath", {
          id: "clip0_7168_65343",
          children: /*#__PURE__*/_jsx("rect", {
            width: "40",
            height: "40",
            rx: "20",
            fill: "white"
          })
        })
      })]
    })
  );
}